import { styled } from "@phntms/css-components";
import styles from "./styles.module.scss";

export const LanguageBarContainer = styled("div", {
  css: [styles.languageBar, "language-bar"],
});
